import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FiltroUsuarioZEComponent } from "./filtro";

type Entity = models.UsuarioZE;
import { columnas } from "./columns";
const resource = resources.UsuarioZE;
;
interface Props2 {
    value?: models.FiltroUsuarioZE;
    onChange: (value: models.FiltroUsuarioZE) => PromiseLike<void> | void;
}

class UsuarioZEListNoRX extends React.PureComponent<Props2> {
    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar UsuarioZE?", x.Nombre)) {
            await resource.delete(x.IdRegistro);
        }
    }

    filtro = (x: Props2) => x.value || {} as models.FiltroUsuarioZE;
    items = createSelectorRx(this.filtro, filtro => observeResource(resource.Query, filtro));
    onEdit = (x: Entity) => history.go(`./${x.IdRegistro}`);
    onAgregar = () => history.go('./new');
    onRegresar = () => history.go('../');

    render() {
        const cols = columnas(this);
        const items = this.items(this.props);
        const filtro = this.filtro(this.props);
        return (
            <div>
                <kea.Title titulo="Proveedores ZE" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>
                <FiltroUsuarioZEComponent {...this.props} value={filtro} />
                <kea.Grid2 columnas={cols} cookieKey={"UsuarioZEListCookieKey"} items={items} />
            </div>
        )
    }
}

interface Props {
    value?: models.FiltroUsuarioZE;
    onChange: (x: models.FiltroUsuarioZE) => void;
}

const UsuarioZEListRX = componentToRx(UsuarioZEListNoRX);
class UsuarioZEListControlled extends React.PureComponent<Props> {
    render() {
        return <UsuarioZEListRX value={this.props.value} onChange={this.props.onChange} />;
    }
}

export const UsuarioZEList =
    kea.makeUncontrolledCookies<Props>("value", "onChange")(UsuarioZEListControlled) as React.ComponentClass<{ cookieKey?: string }>;



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuariosze/list/list.tsx